export default "/images/minus-circle.svg?e04118c7e5f1ff662691ab3cc9d2dd1d";